import { Seo } from "../components/Seo";
import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/home/Marquee";
import { CategoryShowcase } from "../components/home/CategoryShowcase";
import { FeaturedParts } from "../components/home/FeaturedParts";
import { CustomOrdersTeaser } from "../components/home/CustomOrdersTeaser";
import { Manifesto } from "../components/home/Manifesto";
import { BlogPreview } from "../components/home/BlogPreview";
import { ContactCTA } from "../components/home/ContactCTA";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Seo
        title="Orion Services LLC | Heavy Duty Automotive, Truck & Tractor Parts"
        description="Precision engineered automotive, truck and tractor parts — engines, brakes, suspension, hydraulics and more. Transparent SKUs, real stock status, fast quotes."
      />
      <Hero />
      <Marquee />
      <CategoryShowcase />
      <FeaturedParts />
      <CustomOrdersTeaser />
      <Manifesto />
      <BlogPreview />
      <ContactCTA />
    </div>
  );
}
